// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Raleway_99fa2f', '__Raleway_Fallback_99fa2f'","fontStyle":"normal"},"className":"__className_99fa2f","variable":"__variable_99fa2f"};